import request from 'api/request';

export default function fetchInteractions(id) {
  return request({ url: `/courses/${id}/statistics/interactions` });
}
